// frontend-web/src/pages/Admin/StudyContentList.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";

// Confirm Dialog
function ConfirmDialog({ isOpen, onConfirm, onCancel, message, title }) {
  if (!isOpen) return null;
  return (
    <div style={confirmOverlay}>
      <div style={confirmContent}>
        <h3 style={confirmTitle}>Delete Study Content</h3>
        <p style={confirmMessage}>{message}</p>
        <p style={confirmContentTitle}>"{title}"</p>
        <div style={confirmButtons}>
          <button style={confirmYesBtn} onClick={onConfirm}>
            Yes, Delete Permanently
          </button>
          <button style={confirmNoBtn} onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default function StudyContentList() {
  const navigate = useNavigate();

  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [contentToDelete, setContentToDelete] = useState(null);
  // ================================
  // Pagination
  // ================================
  const PAGE_SIZE = 25;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    loadClasses();
  }, []);

  const loadClasses = async () => {
    try {
      const res = await api.get("/admin/study/classes");
      setClasses(res.data);
    } catch (err) {
      console.error("Failed to load classes:", err);
      alert("Failed to load classes");
    }
  };

  const loadSubjects = async (classId) => {
    if (!classId) return;
    setLoading(true);
    try {
      const res = await api.get(`/admin/study/subjects/${classId}`);
      setSubjects(res.data);
      setSelectedSubject(null);
      setContents([]);
      setCurrentPage(1);
      setTotalPages(1);
      setTotalRecords(0);
    } catch (err) {
      console.error("Failed to load subjects:", err);
      alert("Failed to load subjects");
    } finally {
      setLoading(false);
    }
  };

  const loadContents = async (subjectId, page = 1) => {

    if (!subjectId) return;

    if (contentLoading) return;

    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });

    setContentLoading(true);

  try {
    const res = await api.get(
      `/admin/study/content/${subjectId}?page=${page}&limit=${PAGE_SIZE}`
    );

    setContents(res.data.contents || []);

    const safePage =
Math.min(
    res.data.page || 1,
    res.data.total_pages || 1
);

setCurrentPage(safePage);
    setTotalPages(res.data.total_pages || 1);
    setTotalRecords(res.data.total || 0);

  } catch (err) {
    console.error("Failed to load contents:", err);
    alert("Failed to load contents");
  } finally {
    setContentLoading(false);
  }
};

  // FINAL 100% WORKING VIEW FUNCTION – AB SAB DIKHEGA!
  const viewContent = async (contentId) => {
  try {
    const res = await api.get(`/admin/study/content/single/${contentId}`);
    const c = res.data;

    // PDF hai?
    if (c.file_url && c.file_url.trim() && !c.file_url.includes("null")) {
      let pdfUrl = c.file_url.trim();

      // Full URL banao — VITE_API_URL ho ya na ho, dono case handle
      if (pdfUrl.startsWith("/uploads")) {
        const baseUrl =
        process.env.REACT_APP_API_URL ||
        "https://api.eduat10.com/api";
        const apiBase = baseUrl.replace(/\/api$/, "");
        pdfUrl = apiBase.replace(/\/$/, "") + pdfUrl;
      }

      // Token add karo
      const token =
      localStorage.getItem("token") ||
      localStorage.getItem("access_token") ||
      "";
      const separator = pdfUrl.includes("?") ? "&" : "?";
      const finalUrl = `${pdfUrl}${separator}token=${token}`;

      console.log("Opening PDF →", finalUrl);
      window.open(finalUrl, "_blank");
      return;
    }

    // Text hai?
    if (c.content_text && c.content_text.trim()) {
      const win = window.open("", "_blank");
      win.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <title>${c.title || "Content"}</title>
          <style>
            body {font-family: system-ui, sans-serif; background:#f8fafc; padding:40px; margin:0;}
            .box {max-width:900px; margin:0 auto; background:white; padding:40px; border-radius:16px; box-shadow:0 10px 30px rgba(0,0,0,0.1);}
            h1 {color:#1e40af; text-align:center; margin-bottom:30px;}
            .content {line-height:1.9; font-size:17px; background:#f0f9ff; padding:30px; border-radius:12px;}
            img {max-width:100%; border-radius:8px; margin:15px 0;}
          </style>
        </head>
        <body>
          <div class="box">
            <h1>${c.title || "Study Material"}</h1>
            <div class="content">${c.content_text}</div>
          </div>
        </body>
        </html>
      `);
      win.document.close();
      return;
    }

    alert("No content available");

  } catch (err) {
    console.error("View Error:", err);
    alert("Failed to open content");
  }
};

  const requestDelete = (id, title) => {
    setContentToDelete({ id, title: title || "Unknown" });
    setShowConfirm(true);
  };

  const confirmDelete = async () => {
    if (!contentToDelete) return;
    setDeletingId(contentToDelete.id);
    setShowConfirm(false);
    try {
      await api.delete(`/admin/study/content/${contentToDelete.id}`);

        alert(`"${contentToDelete.title}" deleted successfully!`);

        const remaining = contents.length - 1;

        let pageToLoad = currentPage;

        if (remaining === 0 && currentPage > 1) {
          pageToLoad = currentPage - 1;
        }

        if (selectedSubject) {
          loadContents(selectedSubject.id, pageToLoad);
          setCurrentPage(pageToLoad);
        }
    } catch (err) {
      alert("Failed to delete content");
    } finally {
      setDeletingId(null);
      setContentToDelete(null);
    }
  };

  const cancelDelete = () => {
    setShowConfirm(false);
    setContentToDelete(null);
  };
const editContent = (contentId) => {
  navigate(`/admin/study-content-edit/${contentId}`);
};

const getVisiblePages = () => {
  const pages = [];

  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  pages.push(1);

  if (currentPage > 3) {
    pages.push("...");
  }

  const start = Math.max(2, currentPage - 1);
  const end = Math.min(totalPages - 1, currentPage + 1);

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  if (currentPage < totalPages - 2) {
    pages.push("...");
  }

  pages.push(totalPages);

  return pages;
};

  return (
    <div style={pageStyle}>
      <div style={headerStyle}>
        <button onClick={() => navigate(-1)} style={backBtn}>Back to Dashboard</button>
        <h1>Study Content Management</h1>
        <div style={{ width: "150px" }}></div>
      </div>

      <div style={contentStyle}>
        {/* Class Tabs */}
        <div style={stepStyle}>
          <h3>Select Class</h3>
          <div style={tabContainer}>
            {classes.map((cls) => (
              <button
                key={cls.id}
                style={{
                  ...tabStyle,
                  background: selectedClass?.id === cls.id ? "#3b82f6" : "#f1f5f9",
                  color: selectedClass?.id === cls.id ? "white" : "#334155"
                }}
                onClick={() => {
                  setSelectedClass(cls);
                  setSelectedSubject(null);
                  setContents([]);
                  setCurrentPage(1);
                  setTotalPages(1);
                  setTotalRecords(0);
                  loadSubjects(cls.id);
                }}
              >
                {cls.name} ({cls.subjects?.length || cls.subject_count || 0})
              </button>
            ))}
          </div>
        </div>

        {/* Subjects */}
        {selectedClass && (
          <div style={stepStyle}>
            <h3>{selectedClass.name} - Select Subject</h3>
            {loading ? (
              <div style={loadingStyle}><div style={spinner}></div><p>Loading subjects...</p></div>
            ) : (
              <div style={subjectGrid}>
                {subjects.map((sub) => (
                  <div
                    key={sub.id}
                    style={{
                      ...subjectCard,
                      borderColor: selectedSubject?.id === sub.id ? "#3b82f6" : "#e2e8f0",
                      boxShadow: selectedSubject?.id === sub.id ? "0 8px 30px rgba(36, 240, 53, 0.25)" : "none"
                    }}
                    onClick={() => {
                      setSelectedSubject(sub);
                      loadContents(sub.id, 1);
                    }}
                  >
                    <h4>{sub.name}</h4>
                    <p style={subjectCountStyle}>{sub.content_count || 0} Contents</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Contents Table */}
        {selectedSubject && (
          <div style={stepStyle}>
            <h3>
              {selectedSubject.name} - Study Contents
            </h3>

            <p
              style={{
                marginTop: "8px",
                color: "#64748b",
                fontWeight: 600
              }}
            >
              Showing{" "}
              {totalRecords === 0
                ? 0
                : (currentPage - 1) * PAGE_SIZE + 1}
              {" - "}
              {Math.min(currentPage * PAGE_SIZE, totalRecords)}
              {" of "}
              {totalRecords}
            </p>
            <div
              style={{
                marginTop: "8px",
                color: "#2563eb",
                fontWeight: 700
              }}
            >
              Page {currentPage} of {totalPages} • {totalRecords} Total Records
            </div>
            {contentLoading ? (

              <div style={loadingStyle}>
                  <div style={spinner}></div>
                  <p>Loading study contents...</p>
              </div>

              ) : contents.length === 0 ? (
              <div style={emptyState}>
                <div style={emptyIcon}>No content</div>
                <p>No study content added yet!</p>
              </div>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table style={tableStyle}>
                  <thead>
                    <tr style={theadRow}>
                      <th style={thStyle}>#</th>
                      <th style={thStyle}>Title</th>
                      <th style={thStyle}>Type</th>
                      <th style={thStyle}>Access</th>
                      <th style={thStyle}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contents.map((content, index) => (
                      <tr key={content.id} style={trStyle}>
                        <td style={tdStyle}>{(currentPage - 1) * PAGE_SIZE + index + 1}</td>
                        <td style={{ ...tdStyle, fontWeight: 600 }}>
                          {content.title || "Untitled"}
                        </td>
                        <td style={tdStyle}>
                          <span style={{
                            ...badge,
                            background: content.file_url ? "#dbeafe" : "#ecfdf5",
                            color: content.file_url ? "#1e40af" : "#166534"
                          }}>
                            {content.file_url ? "PDF File" : "Text Only"}
                          </span>
                        </td>
                        <td style={tdStyle}>
                          <span style={{ fontWeight: 600, color: content.is_premium ? "#f59e0b" : "#10b981" }}>
                            {content.is_premium ? "Premium" : "Free"}
                          </span>
                        </td>
                        <td style={tdStyle}>
                          <button style={viewBtnSmall} onClick={() => viewContent(content.id)}>
                            View
                          </button>
                          <button style={editBtnSmall} onClick={() => editContent(content.id)}>
                                Edit
                            </button>
                          <button
                            style={{ ...deleteBtnSmall, opacity: deletingId === content.id ? 0.6 : 1 }}
                            onClick={() => requestDelete(content.id, content.title)}
                            disabled={deletingId === content.id}
                          >
                            {deletingId === content.id ? "Deleting..." : "Delete"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "25px"
        }}
      >

        <button
          style={{
            ...backBtn,
            opacity: currentPage === 1 ? 0.5 : 1
          }}
          disabled={currentPage === 1 ||
          contentLoading}
          onClick={() =>
            loadContents(selectedSubject.id, currentPage - 1)
          }
        >
          ← Previous
        </button>

        <div
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap"
          }}
        >
          {getVisiblePages().map((page, index) => {

            if (page === "...") {
              return (
                <span
                  key={`dots-${index}`}
                  style={{
                    padding: "10px 8px",
                    fontWeight: "bold"
                  }}
                >
                  ...
                </span>
              );
            }

            return (
              <button
                key={page}
                disabled={contentLoading}
                onClick={() =>
                  loadContents(selectedSubject.id, page)
                }
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "8px",
                  border: "none",
                  cursor:
                  contentLoading
                  ?
                  "not-allowed"
                  :
                  "pointer",
                  fontWeight: 700,
                  background:
                    page === currentPage
                      ? "#2563eb"
                      : "#e2e8f0",
                  color:
                    page === currentPage
                      ? "white"
                      : "#334155"
                }}
              >
                {page}
              </button>
            );

          })}

        </div>

        <button
          style={{
            ...backBtn,
            opacity:
              currentPage === totalPages ? 0.5 : 1
          }}
          disabled={currentPage === totalPages ||
          contentLoading}
          onClick={() =>
            loadContents(selectedSubject.id, currentPage + 1)
          }
        >
          Next →
        </button>

      </div>
              </div>
              
            )}
          </div>
        )}
      </div>
      

      <ConfirmDialog
        isOpen={showConfirm}
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
        message="Are you sure you want to delete this study content permanently?"
        title={contentToDelete?.title || ""}
      />
    </div>
  );
}

// ALL STYLES – CLEAN & BEAUTIFUL
const pageStyle = { fontFamily: "Inter, system-ui, sans-serif", background: "#f8fafc", minHeight: "100vh", padding: "20px" };
const headerStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", background: "white", padding: "20px 30px", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", marginBottom: "30px" };
const backBtn = { padding: "12px 24px", background: "#6b7280", color: "white", border: "none", borderRadius: "10px", cursor: "pointer", fontWeight: 600 };
const contentStyle = { maxWidth: "1400px", margin: "0 auto" };
const stepStyle = { background: "white", padding: "30px", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", marginBottom: "30px" };
const tabContainer = { display: "flex", flexWrap: "wrap", gap: "12px", marginTop: "20px" };
const tabStyle = { padding: "14px 28px", border: "2px solid #e2e8f0", borderRadius: "12px", background: "#f1f5f9", color: "#334155", cursor: "pointer", fontWeight: 600, transition: "0.3s" };
const subjectGrid = { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: "24px", marginTop: "24px" };
const subjectCard = { padding: "15px", border: "2px solid #e2e8f0", borderRadius: "8px", cursor: "pointer", background: "white", textAlign: "center", transition: "0.3s" };
const subjectCountStyle = { marginTop: "8px", fontWeight: 600, color: "#64748b" };

// Table Styles
const tableStyle = { width: "100%", borderCollapse: "collapse", background: "white", borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0,0.08)" };
const theadRow = { background: "linear-gradient(135deg, #1e40af, #3b82f6)", color: "white" };
const thStyle = { padding: "18px 16px", textAlign: "left", fontWeight: 600, fontSize: "15px" };
const trStyle = { borderBottom: "1px solid #f1f5f9" };
const tdStyle = { padding: "18px 16px", verticalAlign: "middle" };
const badge = { padding: "6px 14px", borderRadius: "999px", fontSize: "13px", fontWeight: 600 };

// Buttons
const viewBtnSmall = { padding: "9px 18px", background: "#10b981", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: 600, marginRight: "8px", fontSize: "13px" };
const deleteBtnSmall = { padding: "9px 18px", background: "#ef4444", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: 600, fontSize: "13px" };

// Dialog & Others
const confirmOverlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 };
const confirmContent = { background: "white", padding: "40px", borderRadius: "20px", textAlign: "center", maxWidth: "480px", width: "90%", boxShadow: "0 25px 50px rgba(0,0,0,0.3)" };
const confirmTitle = { margin: "0 0 16px", fontSize: "22px", fontWeight: 700, color: "#1e293b" };
const confirmMessage = { color: "#64748b", marginBottom: "12px", fontSize: "15px" };
const confirmContentTitle = { color: "#dc2626", fontWeight: 600, background: "#fee2e2", padding: "14px", borderRadius: "10px", margin: "20px 0" };
const confirmButtons = { display: "flex", gap: "16px", justifyContent: "center", marginTop: "20px" };
const confirmYesBtn = { padding: "14px 32px", background: "#dc2626", color: "white", border: "none", borderRadius: "12px", cursor: "pointer", fontWeight: 600 };
const confirmNoBtn = { padding: "14px 32px", background: "#6b7280", color: "white", border: "none", borderRadius: "12px", cursor: "pointer", fontWeight: 600 };

const loadingStyle = { textAlign: "center", padding: "60px" };
const spinner = { width: "36px", height: "36px", border: "4px solid #e2e8f0", borderTop: "4px solid #3b82f6", borderRadius: "50%", animation: "spin 1s linear infinite", display: "inline-block" };
const emptyState = { textAlign: "center", padding: "80px 20px", background: "#f8fafc", borderRadius: "16px", border: "2px dashed #cbd5e1" };
const emptyIcon = { fontSize: "64px", opacity: 0.4 };
const editBtnSmall = { padding: "9px 18px", background: "#f59e0b", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontWeight: 600, marginRight: "8px", fontSize: "13px" };